import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WindowService {
    private windowSizeSubject = new BehaviorSubject<{ width: number; height: number }>({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    windowSize$ = this.windowSizeSubject.asObservable();

    constructor(private ngZone: NgZone) {
        this.listenToResize();
    }

    private listenToResize(): void {
        window.addEventListener('resize', () => {
            this.ngZone.run(() => {
                this.windowSizeSubject.next({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            });
        });
    }
}